import { render, staticRenderFns } from "./PhoneModels.vue?vue&type=template&id=61f45fa6&scoped=true&"
import script from "./PhoneModels.vue?vue&type=script&lang=js&"
export * from "./PhoneModels.vue?vue&type=script&lang=js&"
import style0 from "./PhoneModels.vue?vue&type=style&index=0&id=61f45fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f45fa6",
  null
  
)

export default component.exports